import fileSys from "../fileoprators/fileSystem";
import { objectCopy, isTrue, checkCfg, isDefined } from "../shared/utils";
class SettingsOprator {
  constructor(filepath, defaultSettings) {
    this.filepath = filepath;
    this.defaultSettings = defaultSettings;
  }
  init(filepath, defaultSettings) {
    this.filepath = filepath;
    this.defaultSettings = defaultSettings;
  }
  getSettings() {
    let settings = fileSys.readJsonFile(this.filepath);
    let isSaveBoolean = false;
    if (isDefined(settings)) {
      let check = checkCfg();
      isSaveBoolean = check(settings, this.defaultSettings);
      check = null;
    } else {
      settings = objectCopy(this.defaultSettings);
      isSaveBoolean = true;
    }
    if (isTrue(isSaveBoolean)) {
      fileSys.saveJsonFile(this.filepath, settings);
    }
    return settings;
  }
  saveSettings(settings) {
    fileSys.saveJsonFile(this.filepath, settings);
  }
}
export default SettingsOprator;



// WEBPACK FOOTER //
// ./src/settings/settingsoprator.js